import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BaseService } from './common/base.service';
import { TokenService } from './common/token.service';
import { CryptoJsService } from './crypto-js.service';

@Injectable({
  providedIn: 'root'
})
export class ReportsService extends BaseService {

  protected http: HttpClient;
   user_name:any 
   userId:any;
   isVendor:any;
   officeCode:any;
  constructor(http: HttpClient, tokenService: TokenService,private cryptoJs: CryptoJsService) {
    super(tokenService);
    this.http = http;
  }
  parameter_api(){
    this.user_name= sessionStorage.getItem('User_name_while_login');
    // console.log(this.user_name,"this.user_namethis.user_namethis.user_name")
    this.isVendor= sessionStorage.getItem('isVendor');
    this.officeCode= sessionStorage.getItem('officeCode');
    if(this.user_name === 'DMICADA' || this.user_name === 'ADVISOR'){
      this.userId=encodeURIComponent(this.cryptoJs.Encrypt('DMICADA'))
    }
    else if(this.user_name === 'ADMIN'){
      this.userId=encodeURIComponent(this.cryptoJs.Encrypt('ADMIN'))
    }
    else if(this.user_name === 'CAO'){
      this.userId=encodeURIComponent(this.cryptoJs.Encrypt('CAO'))
    }
    
    
    else  if(this.isVendor){
        this.user_name=this.officeCode;
        this.userId=encodeURIComponent(this.cryptoJs.Encrypt(this.user_name))
      }
      
    else{
      this.userId=encodeURIComponent(this.cryptoJs.Encrypt(this.user_name))
    }
  }

  getAppVerification_MonthWise_Report(selectedYear:any) {
    this.parameter_api()
   return this.http.get<any>(`${environment.apiUrl}Reports/GetAppVerification_MonthWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }

  getAppVerification_DistrictWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetAppVerification_DistrictWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getAppVerification_UserWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetAppVerification_UserWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getAppVerification_VendorWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetAppVerification_VendorWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getEstimation_DistrictWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetEstimation_DistrictWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getEstimation_UserWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetEstimation_UserWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getEstimation_VendorWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetEstimation_VendorWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getEstimation_MonthWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetEstimation_MonthWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }

  getBoq_MonthWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetBOQ_MonthWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getBoq_DistrictWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetBOQ_DistrictWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getBoq_VendorWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetBOQ_VendorWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getBoq_MiType_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetBOQ_MIType_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getEstimationVerification_DistrictWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetEstimateVerification_DistrictWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getEstimationVerification_UserWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetEstimateVerification_UserWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getEstimationVerification_VendorWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetEstimateVerification_VendorWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getEstimationVerification_MonthWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetEstimateVerification_MonthWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getChallan_DistrictWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetChallan_DistrictWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }

  getChallan_VendorWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetChallan_VendorWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getPhysicalVerification_DistrictWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetPhysicalVerification_DistrictWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getPhysicalVerification_UserWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetPhysicalVerification_UserWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getPhysicalVerification_VendorWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetPhysicalVerification_VendorWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getPhysicalVerification_MonthWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetPhysicalVerification_MonthWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getFSV_MonthWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetFSV_MonthWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getFSV_DistrictWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetFSV_DistrictWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }

  getFSV_VendorWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetFSV_VendorWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getSTV_VendorWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetSTV_VendorWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getSTV_MonthWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetSTV_MonthWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getSTV_DistrictWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetSTV_DistrictWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getSTF_DistrictWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetSTF_DistrictWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getSTF_MonthWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetSTF_MonthWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getSTF_VendorWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetSTF_VendorWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getRTF_DistrictWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetRTF_DistrictWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getRTF_MonthWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetRTF_MonthWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getRTF_VendorWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetRTF_VendorWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getMiVerificationSubsidy_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetMiVerificationSubsidy_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getVendorMIArea_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetVendorMIArea_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getTankAbstract_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetTankAbstract_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getStage1_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetStage1_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getStage2_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetStage2_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getStage3_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetStage3_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getStage1_Subsidy_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetStage1_Subsidy_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getStage2_Subsidy_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetStage2_Subsidy_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getStage3_Subsidy_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetStage3_Subsidy_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getCanalAndTubewell_BasedReport(selectedYear:any) {
    return this.http.get<any>(`${environment.apiUrl}Reports/CanalAndTubewellBasedReport?financialyear=${selectedYear}`);
  }
  getChallan_MonthWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetChallan_MonthWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getChallan_Reconciliation_day_Report(selectedYear) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetChallan_Reconciliation_Day_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }  
  getCompletedApplication_DrillDown_Report(actionType,userId,status,filterType,MIType,value,selectedYear){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetCompletedApplication_DrillDown_Report?ActionType=${actionType}&Status=${status}&userId=${userId}&FilterType=${filterType}&MIType=${MIType}&Value=${value}&financialyear=${selectedYear}`);
  }
  getCompletedApplication_Block_DrillDown_Report(actionType,userId,status,filterType,MIType,value,block,selectedYear){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetCompletedApplication_Block_DrillDownReport?ActionType=${actionType}&Status=${status}&userId=${userId}&FilterType=${filterType}&MIType=${MIType}&Value=${value}&Block=${block}&financialyear=${selectedYear}`);
  }

  getTotalApplication_DrillDown_Report(actionType,userId,filterType,value,MIType,selectedYear){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetTotalApplication_DrillDown_Report?ActionType=${actionType}&userId=${userId}&FilterType=${filterType}&Value=${value}&MIType=${MIType}&financialyear=${selectedYear}`);
  }
  getTotalApplication_Block_DrillDown_Report(actionType,userId,filterType,value,MIType,block,selectedYear){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetTotalApplication_Block_DrillDownReport?ActionType=${actionType}&userId=${userId}&FilterType=${filterType}&Value=${value}&MIType=${MIType}&Block=${block}&financialyear=${selectedYear}`);
  }
  getPendingApplication_DrillDown_Report(actionType,userId,duration,filterType,value,MIType,selectedYear){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetPendingApplication_DrillDown_Report?ActionType=${actionType}&userId=${userId}&Duration=${duration}&FilterType=${filterType}&Value=${value}&MIType=${MIType}&financialyear=${selectedYear}`);
  }
  getPendingApplication_Block_DrillDown_Report(actionType,userId,duration,filterType,value,MIType,block,selectedYear){
    
    return this.http.get<any>(`${environment.apiUrl}Reports/GetPendingApplication_Block_DrillDownReport?ActionType=${actionType}&userId=${userId}&Duration=${duration}&FilterType=${filterType}&Value=${value}&MIType=${MIType}&Block=${block}&financialyear=${selectedYear}`);
  }
  getRejectedApplication_DrillDown_Report(actionType,userId,filterType,MIType,value,selectedYear){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetRejectedApplication_DrillDown_Report?ActionType=${actionType}&userId=${userId}&FilterType=${filterType}&MIType=${MIType}&Value=${value}&financialyear=${selectedYear}`);
  }
  getRejectedApplication_Block_DrillDown_Report(actionType,userId,filterType,MIType,value,block,selectedYear){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetRejectedApplication_Block_DrillDownReport?ActionType=${actionType}&userId=${userId}&FilterType=${filterType}&MIType=${MIType}&Value=${value}&Block=${block}&financialyear=${selectedYear}`);
  }

  get7500Report(selectedYear) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/Get7500Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }  

  getAtalReport(selectedYear) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetAtalReport?UserID=${this.userId}&financialyear=${selectedYear}`);
  }  
  getPendingApplication_lot_DrillDown_Report(actionType,userId,duration,filterType,value,MIType,Block,selectedYear){
    
    return this.http.get<any>(`${environment.apiUrl}Reports/getPendingApplication_Lot_DrillDown?ActionType=${actionType}&userId=${userId}&Duration=${duration}&FilterType=${filterType}&Value=${value}&MIType=${MIType}&Block=${Block}&financialyear=${selectedYear}`);
  }
  getTotalApplication_lot_DrillDown_Report(actionType,userId,filterType,value,MIType,Block,selectedYear){
    
    return this.http.get<any>(`${environment.apiUrl}Reports/getTotalApplication_Lot_DrillDown?ActionType=${actionType}&userId=${userId}&FilterType=${filterType}&Value=${value}&MIType=${MIType}&Block=${Block}&financialyear=${selectedYear}`);
  }
  getChallanCompletedApplication_DrillDown_Report(actionType,userId,status,filterType,value,MIType,selectedYear){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetChallanCompletedApplication_DrillDown_Report?ActionType=${actionType}&Status=${status}&userId=${userId}&FilterType=${filterType}&Value=${value}&MIType=${MIType}&financialyear=${selectedYear}`);
  }
  getPondAbstract_DrillDown_Report(userId,district,status,selectedYear){
    return this.http.get<any>(`${environment.apiUrl}Reports/getPondAbstract_DrillDown?userId=${userId}&District=${district}&Status=${status}&financialyear=${selectedYear}`);
  }
  getPondPending_DrillDown_Report(actionType,userId,district,program,selectedYear){
    return this.http.get<any>(`${environment.apiUrl}Reports/getPondPending_DrillDown?ActionType=${actionType}&userId=${userId}&District=${district}&program=${program}&financialyear=${selectedYear}`);
  }
  getPreEstimation_DistrictWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetPreEstimationSurvey_DistrictWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getPreEstimation_UserWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetPreEstimationSurvey_UserWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getPreEstimation_VendorWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetPreEstimationSurvey_VendorWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getPreEstimation_MonthWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetPreEstimationSurvey_MonthWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getAppVerificationTotalApplication_DrillDown_Report(actionType,userId,filterType,value,MIType,selectedYear){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetAppVerificationTotalApplication_DrillDown_Report?ActionType=${actionType}&userId=${userId}&FilterType=${filterType}&Value=${value}&MIType=${MIType}&financialyear=${selectedYear}`);
  }
  getAppVerificationRejectedApplication_DrillDown_Report(actionType,userId,filterType,MIType,value,selectedYear){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetRejectedApplication_DrillDown_Report?ActionType=${actionType}&userId=${userId}&FilterType=${filterType}&MIType=${MIType}&Value=${value}&financialyear=${selectedYear}`);
  }
  getAppVerificationPendingApplication_DrillDown_Report(actionType,userId,duration,filterType,value,MIType,selectedYear){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetAppVerificationPendingApplication_DrillDown_Report?ActionType=${actionType}&userId=${userId}&Duration=${duration}&FilterType=${filterType}&Value=${value}&MIType=${MIType}&financialyear=${selectedYear}`);
  }
  getAppVerificationCompletedApplication_DrillDown_Report(actionType,userId,status,filterType,MIType,value,selectedYear){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetAppVerificationCompletedApplication_DrillDown_Report?ActionType=${actionType}&Status=${status}&userId=${userId}&FilterType=${filterType}&MIType=${MIType}&Value=${value}&financialyear=${selectedYear}`);
  }
  getDDAssociateDailyTaskMI(userId,startDate,endDate){
    
    return this.http.get<any>(`${environment.apiUrl}Reports/DDAssociateDailyTaskMI?Userid=${userId}&startdate=${startDate}&endDate=${endDate}`);
  } 
  getDDAssociateDailyTaskPond(userId,startDate,endDate){
    
    return this.http.get<any>(`${environment.apiUrl}Reports/DDAssociateDailyTaskPond?Userid=${userId}&startdate=${startDate}&endDate=${endDate}`);
  }
  getPondCompleted_DrillDown_Report(actionType,userId,district,program,selectedYear){
    return this.http.get<any>(`${environment.apiUrl}Reports/getPondCompleted_DrillDown?ActionType=${actionType}&userId=${userId}&District=${district}&program=${program}&financialyear=${selectedYear}`);
  }
  getVendor_MI_Area_Report(userId,status,MIType,value,selectedYear){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetVendorMIAreaReport_DrillDown?userId=${userId}&status=${status}&vendorCode=${value}&Component=${MIType}&financialyear=${selectedYear}`);
  }
  getChallanTotalApplication_DrillDown_Report(actionType,userId,status,filterType,value,MIType,selectedYear){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetChallanTotalApplication_DrillDown_Report?ActionType=${actionType}&userId=${userId}&FilterType=${filterType}&Value=${value}&MIType=${MIType}&financialyear=${selectedYear}`);
  } 
  getConsolidated_Report(financialYear){
    return this.http.get<any>(`${environment.apiUrl}Reports/getmiconsolidatedreport?financialyear=${financialYear}`);
  }
  getPondConsolidated_Report(financialYear){
    return this.http.get<any>(`${environment.apiUrl}Reports/getpondconsolidatedreport?financialyear=${financialYear}`);
  }
  getFinanacialYearList(){
    return this.http.get<any>(`${environment.apiUrl}Reports/getfinancialyearlist`);
  }
}
